import { DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransferToInvoicing extends Layout {
    excludabletextboxBookingNumber: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxH: ExcludableTextbox;
    excludabletextboxMasterOrder: ExcludableTextbox;
    excludabletextboxOrderMove: ExcludableTextbox;
    sourceTransferToInvoicingMultiple: DataSource;
    textboxBillingMethod: Textbox;
    textboxBillingUser: Textbox;
    textboxDeliveryDate: Textbox;
    textboxFilterType: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxInvoiceProcessor: Textbox;
}
